import 'magnific-popup';

var Popup = function ($el, opts) {

    this.$el = $el;
    this.$popup = $($el.attr('href'));

    this.init();
};


Popup.prototype.init = function () {
    this.$el.on('click', function () {
        this.show();
    }.bind(this));

    if (this.initialised) return;

};

Popup.prototype.show = function () {
    $.magnificPopup.open({
        items: {
            src: this.$popup
        },
        type: 'inline'
    });
};

Popup.init = function ($scope) {
    $($scope || '[data-popup]').each(function (i, el) {
        if (!$(el).data('VideoHero')) {
            $(el).data('VideoHero', new Popup($(el), $(el).data()));
        }
    }.bind(this));

    if (!this.initialised) this.initialised = true;

};

export default Popup;